<template>
    <div class="d-flex flex-column">
        <b-table v-if="!carregandoVerificaSeTemCat && existeAlgumFormularioCat" class="mt-3 py-5" striped :items="items" :fields="fields" show-empty :busy="carregandoBuscarItemsTabela" responsive>
			<template #empty>
                    <div class="d-flex">
                        <span class="mx-auto">
                            Nenhum Registro Encontrado
                        </span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
				<template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
				<template #cell(empresa)="data">
					{{ data.item.razaoSocial }}
				</template>
				<template #cell(funcionario)="data">
					{{ data.item.nomeFuncionario + " - " + $options.filters.addMascara(data.item.cpfFuncionario, "cpf") }}
				</template>
				<template #cell(dataInicio)="data">
					{{ $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY HH:mm") }}
				</template>
				<template #cell(acao)="data">
					<b-button size="sm" variant="secondary" @click="visualizarCat(data.item.id)">Visualizar CAT</b-button>
				</template>
		</b-table>
		<div class="my-2 d-flex flex-column" v-if="!carregandoVerificaSeTemCat && !carregandoBuscarItemsTabela && existeAlgumFormularioCat">
            <span>Total: {{ numeroDeLinhasTabela }}</span>
        </div>
		<b-pagination v-if="!carregandoVerificaSeTemCat && !carregandoBuscarItemsTabela && existeAlgumFormularioCat" @input="consultaCatsJaEnviadosPorUsuario()" class="mx-auto" v-model="paginaAtualTabela" :total-rows="numeroDeLinhasTabela" :per-page="itemsPorPagina" ></b-pagination>
		<div v-if="!existeAlgumFormularioCat && !carregandoVerificaSeTemCat" class="py-5 d-flex flex-row justify-content-center align-items-center w-100 mx-auto" style="background-color: hsl(0, 0%, 50%, 0.2);border-radius: 10px;">
				<span style="color: gray; font-size: 18px;">
					Nenhum CAT Enviado
				</span>
		</div>
		<b-spinner v-if="carregandoVerificaSeTemCat" variant="dark" class="mx-auto"></b-spinner>
    </div>
</template>

<script>
import CatService from "../../service/CatService.js";


export default {
	components: {},
	name: "TableCatJaEnviadoPorUsuario",
	props: [ "usuario" ],
	data() {
		return {
			carregandoBuscarItemsTabela: false,
			carregandoVerificaSeTemCat: false,
			existeAlgumFormularioCat: false,
			items: [],
			fields: [
				{
					label: "#",
				 	key: "index",
				},
				{
					label: "Funcionário",
					key: "funcionario",
				},
				{
					label: "Empresa",
					key: "Empresa",
				},
				{
					label: "Data/Hora Envio",
					key: "dataInicio",
				},
				{
					label: "",
					key: "acao",
				},
			],

			paginaAtualTabela: 1,
			numeroDeLinhasTabela: 0,
			itemsPorPagina: 10,
		};
	},
	created() {
		this.inicializar();
	},
	methods: {
		async inicializar() {
			await this.verificaSeHaCatEnviadoPorUsuario();
			await this.buscaCatsJaEnviadosPorUsuario();
		},
		async verificaSeHaCatEnviadoPorUsuario() {
			this.carregandoVerificaSeTemCat = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			return CatService.verificaSeHaCatEnviadoPorUsuario(usuarioLogado.id)
				.then((res) => {
					this.existeAlgumFormularioCat = res.data;
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível verificar se há algum cat já enviado", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregandoVerificaSeTemCat = false;
				});
		},
		buscaCatsJaEnviadosPorUsuario() {
			this.paginaAtualTabela = 1;
			return this.consultaCatsJaEnviadosPorUsuario();
		},
		async consultaCatsJaEnviadosPorUsuario() {
			this.carregandoBuscarItemsTabela = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			return CatService.consultar(usuarioLogado.id, this.paginaAtualTabela - 1, this.itemsPorPagina)
				.then((res) => {
					this.items = res.data[0];
					this.numeroDeLinhasTabela = res.data[1];
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível consultar os cats já enviados", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregandoBuscarItemsTabela = false;
				});
		},
		visualizarCat(catId) {
			this.$emit("visualizarCat", catId);
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/Cat/TableCatJaEnviadoPorUsuario.vue